<template>
    <div class="w-full px-10 py-6 rounded-2xl bg-TextField flex flex-col space-y-3 items-center text-sm">
        <p class="w-full text-sm text-MittelGrau font-bold">Ab dem {{ aboBeginn }}:</p>

        <!-- Grundpreis -->
        <div v-if="laedt === false" class="w-full flex justify-between items-end">
            <span :class="{ 'w-[70%]': mobile === true }">{{ gp.beschreibung }}:</span>
            <span>{{ positionZuWertString(gp) }}</span>
        </div>
        <div v-else class="w-full flex justify-between">
            <LadeElement class="w-[40%]" />
            <LadeElement class="w-24" />
        </div>

        <!-- Preisminderungen -->
        <div v-for="w in pm" :key="w.index" class="w-full flex justify-between">
            <span :class="{ 'w-[70%]': mobile === true }">{{ w.beschreibung }}:</span>
            <span>- {{ positionZuWertString(w) }}</span>
        </div>

        <Divider />

        <!-- Netto -->
        <div v-if="laedt === false" class="w-full flex justify-between">
            <span :class="{ 'w-[70%]': mobile === true }">{{ netto.beschreibung }}:</span>
            <span>{{ positionZuWertString(netto) }}</span>
        </div>
        <div v-else class="w-full flex justify-between">
            <LadeElement class="w-28" />
            <LadeElement class="w-24" />
        </div>

        <!-- MwST -->
        <div v-if="laedt === false" class="w-full flex justify-between">
            <span :class="{ 'w-[70%]': mobile === true }">{{ mwst.beschreibung }}:</span>
            <span>+ {{ positionZuWertString(mwst) }}</span>
        </div>
        <div v-else class="w-full flex justify-between">
            <LadeElement class="w-28" />
            <LadeElement class="w-24" />
        </div>

        <Divider />

        <!-- Brutto -->
        <div v-if="laedt === false" class="w-full flex justify-between font-bold">
            <span>{{ brutto.beschreibung }}:</span>
            <span>{{ positionZuWertString(brutto) }} / {{ jaehrlich === true ? "Jahr" : "Monat" }}{{ pmInfoText == null ? ''
                : ' *' }}</span>
        </div>
        <div v-else class="w-full flex justify-between">
            <LadeElement class="w-28" />
            <LadeElement class="w-24" />
        </div>

        <span v-if="laedt === false && pmInfoText != null" class="w-full pt-2 text-xs" v-html="pmInfoText"></span>
        <div class="w-full flex flex-col space-y-2 pt-3" v-else-if="laedt === true && pmInfoText != null">
            <LadeElement class="w-full" />
            <LadeElement class="w-1/3" />
        </div>
    </div>
</template>
<script>
import LadeElement from "./LadeElement.vue"
import Divider from "./Divider.vue"
import { computed } from 'vue';
import { preisStringGenerieren } from "@/dienste/helfer";
import store from "@/store";
import dayjs from "dayjs";
export default {
    components: { LadeElement, Divider },
    props: ["mobile"],
    setup(props, context) {

        /** Konvertiert ein "Rechnungsposition" Objekt in einen "x,yz €" String*/
        function positionZuWertString(rechnungsposition) {
            return `${preisStringGenerieren(rechnungsposition.wert)} €`
        }

        const laedt = computed(() => store.state.rechnungsPositionenLaden)

        const jaehrlich = computed(() => store.state.frist === "j")

        const aboBeginn = computed(() => {
            if (laedt.value === false) {
                return dayjs.unix(store.state.abonnementBeginn).format("DD.MM.YYYY")
            }
        })

        const gp = computed(() => {
            if (laedt.value === false) {
                return store.state.abonnementRP.find(k => k.art === "grundpreis")
            }
        })

        const pm = computed(() => {
            if (laedt.value === false) {
                return store.state.abonnementRP.filter(k => k.art === "preisminderung").sort((a, b) => a.index - b.index)
            }
        })

        const netto = computed(() => {
            if (laedt.value === false) {
                return store.state.abonnementRP.find(k => k.art === "netto")
            }
        })

        const mwst = computed(() => {
            if (laedt.value === false) {
                return store.state.abonnementRP.find(k => k.art === "mwst")
            }
        })

        const brutto = computed(() => {
            if (laedt.value === false) {
                return store.state.abonnementRP.find(k => k.art === "brutto")
            }
        })

        const pmInfoText = computed(() => {
            if (laedt.value === false && pm.value && pm.value.length > 0) {
                return "* Hierbei handelt es sich um den reduzierten Preis. Nach Ablauf des Gutscheincodes erhöht sich der Betrag automatisch auf den regulären Preis des gewählten Pakets. Es gelten die <a>allgemeinen Geschäftsbedingungen</a>"
            }
        })

        return {
            jaehrlich,
            laedt,
            gp,
            pm,
            netto,
            mwst,
            brutto,
            pmInfoText,
            aboBeginn,
            positionZuWertString
        }
    }
}
</script>